export enum medicalServicesTypesEnum {
  MEDICAL_SERVICES_FAILURE = 'MEDICAL_SERVICES_FAILURE',
  SET_MEDICAL_SERVICES = 'SET_MEDICAL_SERVICES',
  MEDICAL_SERVICES_REQUEST = 'MEDICAL_SERVICES_REQUEST',
}
